import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { Row, Button, Input, Select } from 'antd';
import { useHistory } from 'react-router';
import withStyles from 'react-jss';
import startCase from 'lodash/startCase';
import { Controller, useForm } from 'react-hook-form';

import styles from '../styles';
import { successNotification, errorNotification } from '../Snackbar';
import Api from '../Api';
import CenterGrid from '../Components/CenterGrid';
import GetField from '../Components/GetField';
import constants from '../constants';
import Breadcrumbs from '../Components/Breadcrumbs';

const AntInput = GetField(Input);
const AntSelect = GetField(Select);
const { Option } = Select;

const CreateRole = props => {
  const { classes } = props;
  const history = useHistory();

  const { handleSubmit, control } = useForm();

  const [confirmLoading, setConfirmLoading] = useState(false);

  const onSubmit = useCallback(async formValues => {
    try {
      setConfirmLoading(true);
      await Api.post('/roles', formValues);
      successNotification('Role created');
      history.push('/roles/list');
    } catch (err) {
      setConfirmLoading(false);
      errorNotification(err);
    }
  }, []);

  return (
    <>
      <Breadcrumbs
        moduleName="Role"
        moduleLink="/roles/list"
        subModuleName="Create"
      />
      <form onSubmit={handleSubmit(onSubmit)}>
        <Row>
          <CenterGrid>
            <Controller
              name="role"
              control={control}
              render={({ field }) => (
                <AntInput
                  allowClear
                  label="Role"
                  placeholder="Role"
                  {...field}
                />
              )}
            />
          </CenterGrid>
        </Row>
        <Row>
          <CenterGrid>
            <Controller
              name="permissions"
              control={control}
              render={({ field }) => (
                <AntSelect
                  allowClear
                  mode="multiple"
                  label="Permissions"
                  placeholder="Select permissions"
                  {...field}
                >
                  {Object.values(constants.permissions).map(module => (
                    <Option key={module} value={module}>
                      {startCase(module)}
                    </Option>
                  ))}
                </AntSelect>
              )}
            />
          </CenterGrid>
        </Row>
        <Row className={classes.buttonContainer}>
          <Button type="primary" loading={confirmLoading} htmlType="submit">
            Submit
          </Button>
        </Row>
      </form>
    </>
  );
};

CreateRole.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(CreateRole);
